import { IRootState } from './../root-state.interface';

export const selectActivities = (state: IRootState) => state.activities;
